import type DbDataModel from '../../../models/DbDataModel';
import { requestAndParse, requestSuccessful } from '../request';

const getPayments = async () => {
    const route = 'admin/get-payments';
    const payload = {};

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const payments = response.body?.payments as DbDataModel[];
    const message = response.body?.message as string;

    return { success, payments, message };
};

export default getPayments;
